import makeStyles from '@material-ui/styles/makeStyles';

export const useStyles = makeStyles({
  root: {
    minHeight: '100vh',
    width: '100%',
    backgroundColor: '#F9F9F9',
  },
  content: {
    marginTop: '64px',
  }
});
